export const SEND_FILE = 'tools/SEND_FILE';
export const SEND_TRANSCRIPT = 'tools/SEND_TRANSCRIPT';
export const PRINT_TRANSCRIPT = 'tools/PRINT_TRANSCRIPT';
export const SHOW_BROWSER_NOTIFICATION = 'tools/SHOW_BROWSER_NOTIFICATION';

export const sendFile = file => ({
  type: SEND_FILE,
  payload: file,
});

export const printTranscript = htmlMessage => ({
  type: PRINT_TRANSCRIPT,
  payload: htmlMessage,
});

export const sendTranscript = email => ({
  type: SEND_TRANSCRIPT,
  payload: email,
});

export const showBrowserNotification = (title, body, roomId) => ({
  type: SHOW_BROWSER_NOTIFICATION,
  payload: { title, body },
  meta: { roomId },
});
